<div class="p-invalid-from-message" [ngClass]="{'warnning': messageType}">
    <span><i  [ngClass]="['pi '+icon]"></i></span>
    <small id="username-help" class="p-error">{{message}}</small>
</div>
